<template>
  <v-card flat class="pa-4">
    <div class="text-caption text-uppercase primary--text font-weight-bold mb-1">Step 2 of 3</div>
    <v-card-title class="text-h4 font-weight-black mb-2 pa-0 text--primary">
      Sell Your {{ value.pageType === 'product' ? 'Product' : 'Service' }}
    </v-card-title>
    <v-card-subtitle class="pa-0 mb-8 text-subtitle-1">
      Verify the extracted details or add your own to help our AI generate compelling copy and structure your page sections.
    </v-card-subtitle>

    <v-card-text class="pa-0">
      <v-textarea v-model="businessDescription"
        class="customBorderRadius mb-6"
        :label="value.pageType === 'product' ? 'What does your product do? *' : 'What does your business do? *'"
        placeholder="Describe it in a few sentences. This helps our AI generate better content for your landing page."
        outlined
        rows="4"
      />

      <v-combobox
        v-model="usps"
        label="What is your USP (Unique Selling Proposition)?"
        placeholder="Type a USP and press Enter (e.g. Free shipping, 24/7 Support)"
        outlined
        hide-details="auto"
        multiple
        chips
        small-chips
        deletable-chips
        append-icon=""
        class="mb-6 customBorderRadius"
      >
        <template v-slot:append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" color="grey" v-on="on">mdi-help-circle-outline</v-icon>
            </template>
            <span>What makes you stand out from the competition? Press Enter after each point.</span>
          </v-tooltip>
        </template>
      </v-combobox>

      <v-combobox
        v-model="features"
        label="Features you wish to mention"
        placeholder="Type a feature and press Enter (e.g. Waterproof, Dashboard)"
        outlined
        hide-details="auto"
        multiple
        chips
        small-chips
        deletable-chips
        append-icon=""
        class="mb-6 customBorderRadius"
      />
      
      <p class="text-subtitle-1 font-weight-medium mb-2 mt-4">FAQs (Optional)</p>
      <div v-for="(faq, index) in faqs" :key="'faq-' + index" class="d-flex align-start mb-2">
        <v-text-field v-model="faqs[index].q" class="customBorderRadius mr-2" label="Question" outlined dense hide-details />
        <v-text-field v-model="faqs[index].a" class="customBorderRadius mr-2" label="Answer" outlined dense hide-details />
        <v-btn class="customBorderRadius" icon color="error" @click="faqs.splice(index, 1)"><v-icon>mdi-delete</v-icon></v-btn>
      </div>
      <v-btn class="customBorderRadius mb-6" text small color="primary" @click="faqs.push({q:'', a:''})">
        <v-icon left>mdi-plus</v-icon> Add FAQ
      </v-btn>
      
    </v-card-text>

    <v-card-actions class="pa-0 mt-8">
      <v-btn class="customBorderRadius px-6 font-weight-bold" text large @click="$emit('back')">
        <v-icon left>mdi-arrow-left</v-icon>
        Back
      </v-btn>
      <v-spacer />
      <v-btn class="customBorderRadius px-8 font-weight-bold"
        color="primary"
        large
        depressed
        @click="next"
      >
        Next Step
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "WizardStep2",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    var content = this.value.pageContent || {};
    return {
      businessDescription: this.value.businessDescription || "",
      usps: content.usps || [],
      features: content.features || [],
      faqs: content.faq || [],
    };
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        if (val.businessDescription !== this.businessDescription) {
           this.businessDescription = val.businessDescription;
        }
        var content = val.pageContent || {};
        if (content.usps) this.usps = content.usps;
        if (content.features) this.features = content.features;
        if (content.faq) this.faqs = content.faq;
      }
    }
  },
  methods: {
    next() {
      var validFaqs = this.faqs.filter(function(f) { return f.q && f.q.trim() !== ''; });

      this.$emit("input", {
        ...this.value,
        businessDescription: this.businessDescription.trim(),
        pageContent: {
          ...(this.value.pageContent || {}),
          usps: this.usps,
          features: this.features,
          faq: validFaqs,
        },
      });
      this.$emit("next");
    },
  },
};
</script>